import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments';
import { TenantService } from '../../authentication/service/tenantService';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-logo',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css'],
  imports: [NgOptimizedImage],
})
export class LogoComponent implements OnInit {
  private readonly tenantService = inject(TenantService);

  tenantId!: string;
  publicResourcesUrl = environment.publicResourcesUrl;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit() {
    this.tenantId = this.tenantService.tenant;
  }
}
